import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ESystemNoticeSeverity, ESystemNoticeType, ISystemNotice, TSystemNoticeSeverity, TSystemNoticeType } from '../interfaces/custom.interfaces';

@Injectable({
  providedIn: 'root'
})
export class NoticeService {

  // felső notification popuphoz használjuk, minden amit ebbe beleírunk, az meg fog jelenni ott is
  private notificationSubject: BehaviorSubject<ISystemNotice[]> = new BehaviorSubject([]);

  notifications$ = this.notificationSubject.asObservable();

  activeDots = signal<string[]>([]);

  // csak célzottan használjuk
  private noticeSubject: BehaviorSubject<ISystemNotice> = new BehaviorSubject(null);

  changed$ = this.noticeSubject.asObservable();

  setNotice(message: string, type: TSystemNoticeType = ESystemNoticeType.General, severity: TSystemNoticeSeverity = ESystemNoticeSeverity.Info): void {
    
    const notice: ISystemNotice = {
      message,
      severity,
      type
    };

    this.noticeSubject.next(notice);
  }

  setNotification(message: string, source?: string, name?: string, type: TSystemNoticeType = ESystemNoticeType.General, severity: TSystemNoticeSeverity = ESystemNoticeSeverity.Info): void {
    
    const notifications: ISystemNotice[] = this.notificationSubject.getValue();

    notifications.push({
      name,
      source,
      message,
      severity,
      type,
      timestamp: new Date,
      seen: false
    });

    this.notificationSubject.next(notifications);
  }

  /**
   * Hozzáadunk az activeDot signalhoz egy adott elemet
   * 
   * @param name 
   */
  addDot(name: string): void {

    if (!this.activeDots().includes(name)) {
      
      // lekérjük az aktuális tartalmat
      const dots = this.activeDots();
      // seteljük az új itemet
      dots.push(name);

      // beállítjuk az új state-t
      this.activeDots.set(dots);
    }
      
  }

  /**
   * Eltávolítunk az activeDot signalból egy adott elemet
   * 
   * @param name 
   */
  removeDot(name: string): void {

    if (this.activeDots().includes(name)) {

      // lekérjük az aktuális tartalmat
      const dots = this.activeDots();
      // töröljük a megfelelő itemet
      dots.splice(this.activeDots().indexOf(name), 1);

      // beállítjuk az új state-t
      this.activeDots.set(dots);
    }

  }

}
